import * as Constants from './Constants';

const initialState = {
  title: 'Payment Info',
  cardPaymentsSendLinkTriggered: 'false',
  enablePayment: false,
  expiration: null,
  cardNumberValue: null,
  cvv: null,
  zipcode: null,
  confirmSubmitCall: false,
  selectedPayment: null,
  expDate: null,
  eciData: {},
  paymentZipDetailsError: false,
  showPaymentApiError: null,
  paymentServiceInfo: '',
  paymentError: false,
  paymentNtfyMsg: null,
  isInvalidZipcodeError: false,
};

function paymentInfo(state = initialState, action) {
  switch (action.type) {
    case Constants.PAYMENT_OPTIONS_RECEIVED:
      return { ...state, data: action.response };
    case Constants.IS_NON_3D_RECEIVED:
      return { ...state, isNon3D: action.response };
    case Constants.UPDATE_3DS_INFO:
      return { ...state, is3DSecureCard: action.response['3DSecureEnabled'], paymentInfoSecured: action.response };
    case Constants.SAVE_CARD_DETAILS:
      return { ...state, savedcardInfo: action.data };
    case Constants.IS_PAYPAL_CHOOSEN:
      return { ...state, paypalDataPosted: action.paypalDataPosted };
    case Constants.SHOW_WARN_ERROR:
      return { ...state, errorDetails: action.errorDetails };
    case Constants.REMOVE_NOTIFICATION:
      return { ...state, errorDetails: action.errorDetails };
    case 'SENDLINK_ACTION_TRIGGERED':
      return { ...state, cardPaymentsSendLinkTriggered: action.data };
    case 'ENABLE_PAYMENT_SUBMIT':
      return { ...state, enablePayment: action.response };
    case 'FETCH_CARD_EXPIRATION':
      return { ...state, expiration: action.response };
    case 'FETCH_CARD_NUMBER':
      return { ...state, cardNumberValue: action.response.cardNumber, originalCardValue: action.response.originalCardValue };
    case 'FETCH_CARD_CVV':
      return { ...state, cvv: action.response };
    case 'FETCH_ZIPCODE':
      return { ...state, zipcode: action.response };
    case 'PAYMENT_SUCESS':
      return { ...state, paymentSuccess: action.apiResponse };
    case 'CONFIRM_SUBMIT_CALL':
      return { ...state, confirmSubmitCall: action.value };
    case 'REDIRECT_DONE':
      return { ...state, redirectDone: action.value };
    case 'SELECTED_PAYMENT':
      return { ...state, selectedPayment: action.value };
    case 'EXP_DATE':
      return { ...state, expDate: action.value };
    case 'CALL_3D_API':
      return { ...state, eciData: action.response };
    case 'ENABLE_3D_CARD':
      return { ...state, enable3DCard: action.response };
    case 'RESET_PAYMENT':
      return { ...state, paymentSuccess: {} };
    case Constants.PAYMENT_ZIP_DETAILS_FAILED:
      return { ...state, paymentZipDetailsError: action.response };
    case Constants.SHOW_PAYMENT_API_ERROR:
      return { ...state, showPaymentApiError: action.errorDetails, paymentServiceInfo: action.serviceinfo };
    case Constants.SET_PAYPAL_ERROR:
      return { ...state, isPostPaymentPaypalError: action.response };
    case Constants.RESET_PAYPAL_ERROR:
      return { ...state, isPostPaymentPaypalError: action.response };
    case Constants.MAX_ATTEMPT_ERROR:
      return { ...state, maxAttemptError: action.response };
    case Constants.CEF_PAYMENT_INFO_ERROR:
      return { ...state, paymentError: action.response, paymentNtfyMsg: action.errorMessage };
    case Constants.CEF_CHECKOUT_DETAILS_ERROR:
      return { ...state, paymentError: action.response, paymentNtfyMsg: action.errorMessage };
    default:
      return state;
  }
}

export default paymentInfo;
